import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('rates_batch_publishing')
const reducer = generator.generate()

export default reducer
